<template>

    <div v-if="! readonly || slot.guests.length" class="px-4 py-3 rounded-sm bg-gray-200">

        <div class="text-sm text-muted"
            v-if="! resourceAcceptsGuests"
        >Tento zdroj nedovoluje zvát hosty</div>

        <div v-else>
            <div v-if="hasFocus || slot.guests.length || tags.length" class="text-xs text-muted uppercase">Hosté</div>

            <div class="text-sm text-muted"
                v-if="readonly && slot.guests.length"
                v-text="slot.guests.map(guest => guest.fullName || guest.email).join(', ')"
            ></div>

            <vue-tags-input
                v-if="! readonly"
                class="reservation-guests-input"
                v-model="tag"
                :placeholder="placeholder"
                :tags="tags"
                :autocomplete-items="autocompleteItems"
                @focus="hasFocus = true"
                @blur="hasFocus = false"
                @tags-changed="update"
            >
                <div
                    slot="autocomplete-item"
                    slot-scope="props"
                    class="my-item"
                    @click="props.performAdd(props.item)"
                    >
                    {{ props.item.text }}
                    <span class="inline-block pl-2 text-xs text-muted">{{ props.item.email }}</span>
                </div>
            </vue-tags-input>
        </div>

    </div>

</template>

<script>
import VueTagsInput from "@johmun/vue-tags-input";
import axios from "axios";

export default {
    components: {
        VueTagsInput,
    },

    props: {
        resourceAcceptsGuests: {
            type: Boolean,
            default: false
        },
        readonly: {
            type: Boolean,
            default: true
        }
    },

    data() {
        return {
            slot: this.$store.slot,
            hasFocus: false,
            tag: '',
            tags: [],
            autocompleteItems: [],
            debounce: null,
        };
    },

    computed: {
        placeholder() {
            return this.hasFocus || this.tags.length
                ? '...'
                : 'Přidat hosty';
        },
    },

    watch: {
        tag: 'updateAutocompleteItems',
    },

    methods: {
        update(selectedAutocompleteItems) {
            this.autocompleteItems = [];
            this.tags = selectedAutocompleteItems;
            this.slot.guestEmails = this.tags.map(item => item.email || item.text);
        },
        updateAutocompleteItems() {
            if (this.tag.length < 2) return;
            const url = `/api/v1/user-autocomplete-data?q=${this.tag}`;

            clearTimeout(this.debounce);
            this.debounce = setTimeout(() => {
                axios
                    .get(url)
                    .then((response) => {
                        this.autocompleteItems = response.data;
                    })
                    .catch(() => console.warn('Error loading autocomplete'));
            }, 500);
        },
    },

    mounted() {
        this.tags = this.slot.guests.map(guest => {
            return {
                email: guest.email,
                text: guest.fullName || guest.email
            }
        });
    }
};
</script>

<style lang="scss">
    .reservation-guests-input {
        &.vue-tags-input {
            margin: 0 -5px;
            border: none !important;

            .ti-tags {
                margin: 0;
            }

            .ti-new-tag-input {
                &::placeholder {
                    color: var(--muted);
                }
            }
        }
    }
</style>
